import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'src/Member/components/common/skeleton';

const NotificationPopupSkeleton = () => {
  return (
    <>
      <Card className="p-2">
        <Row className="d-flex flex-row m-1">
          <Col md={2} lg={2} sm={2} className="p-2">
            <Skeleton height={55} width={55} count={1} circle={true} />
          </Col>
          <Col className="p-2 pl-3">
            <Skeleton width="80%" height={20} count={1} className="" />
            <br />
            <Skeleton width="60%" height={14} count={1} className="pt-2" />
          </Col>
        </Row>
        <hr className="m-0" />
        <Row className=" d-flex flex-row m-1 align-items-center justify-content-between ">
          <Col md={4} lg={4} sm={4} className="p-1">
            <Skeleton width="100%" height={18} count={1} />
          </Col>
          <Col md={4} lg={4} sm={4} className="p-1">
            <Skeleton width="100%" height={18} count={1} />
          </Col>
        </Row>
        <hr className="m-0" />

        <Row className="d-flex flex-row m-1">
          <Col md={2} lg={2} sm={2} className="p-2">
            <Skeleton height={55} width={55} count={1} circle={true} />
          </Col>
          <Col className="p-3" md={7} lg={7} sm={7}>
            <Skeleton width="100%" height={14} count={1} className="mb-2" />
            <Skeleton width="60%" height={14} count={1} className="" />
          </Col>
          <Col md={3} lg={3} sm={3} className="p-3">
            <Skeleton width="100%" height={12} count={1} className="mb-2" />
            <Skeleton width="100%" height={12} count={1} className="" />
          </Col>
        </Row>
        <hr className="m-0" />
        <Row className="d-flex flex-row m-1">
          <Col md={2} lg={2} sm={2} className="p-2">
            <Skeleton height={55} width={55} count={1} circle={true} />
          </Col>
          <Col className="p-3" md={7} lg={7} sm={7}>
            <Skeleton width="100%" height={14} count={1} className="mb-2" />
            <Skeleton width="60%" height={14} count={1} className="" />
          </Col>
          <Col md={3} lg={3} sm={3} className="p-3">
            <Skeleton width="100%" height={12} count={1} className="mb-2" />
            <Skeleton width="100%" height={12} count={1} className="" />
          </Col>
        </Row>
        <hr className="m-0" />
        <Row className="d-flex flex-row m-1">
          <Col md={2} lg={2} sm={2} className="p-2">
            <Skeleton height={55} width={55} count={1} circle={true} />
          </Col>
          <Col className="p-3" md={7} lg={7} sm={7}>
            <Skeleton width="100%" height={14} count={1} className="mb-2" />
            <Skeleton width="60%" height={14} count={1} className="" />
          </Col>
          <Col md={3} lg={3} sm={3} className="p-3">
            <Skeleton width="100%" height={12} count={1} className="mb-2" />
            <Skeleton width="100%" height={12} count={1} className="" />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default NotificationPopupSkeleton;
